// extracted by mini-css-extract-plugin
export default {"container":"AddProduct_container__si+3Q","form":"AddProduct_form__G19zh","form__button":"AddProduct_form__button__ygmUe","heading":"AddProduct_heading__vj91w"};